import z from "zod";
export const userSchema = z.object({
    email: z
        .string()
        .nonempty("Email is required")
        .email("Please enter a valid email address"),
    firstName: z.string().nonempty("First name is required"),
    lastName: z.string().nonempty("Last name is required"),
    roleId: z.string().nonempty("Role is required"),
    companyId: z.string().nullable(),
});
